<style>
</style>

<!-- SNACKBAR FOR ON-DISPLAY MESSAGES -->
  <template>
    <v-snackbar 
      v-model="show"
      :timeout="snackbar_timeout"
      :color="snackbar_style === 'success' ? 'green' : 'red'"
      rounded="pill">
      {{ snackbar_message }}
      <template v-slot:actions>
        <v-btn
          color="black"
          variant="text"
          @click="show = false"
        >
          Chiudi
      </v-btn>
      </template>
    </v-snackbar>
  </template>

  <script>
    export default {
      name: 'snackbarTemplate',
      data() {
        return {
          show: false,
          snackbar_style: '',
          snackbar_message: '',
          snackbar_timeout: 2000,
        } 
      },
    }
  </script>
